module.exports = "https://static.energy5.com/_next/static/images/book-mobile-d4af9c263b3b2622df215a16b7d7dbe3.png";